import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  // Link,
  Redirect
} from 'react-router-dom';
// import logo from './logo.svg';
import './App.css';
import { Auth } from 'aws-amplify';
import AwsAmplifyConfig from './components/AwsAmplifyConfig.js';
import BeangoNavbar from './components/BeangoNavbar.js';
import InfoForm from './components/InfoForm.js';
// import OrderForm from './components/OrderForm.js';
// import AddNewGrowerForm from './components/AddNewGrowerForm.js';
// import {firestoreDb, firebase} from './firebaseInit.js';
import SignInForm from './components/SignInForm.js';
import SignUpForm from './components/SignUpForm.js';
import SignUpEmailConfirm from './components/SignUpEmailConfirm.js';
import SignInResetPwd from './components/SignInResetPwd.js';
//This is for the yc demo only. Remmmeber to remove
import SignInAuto from './components/SignInAuto.js';
// import SignOutForm from './components/SignOutForm.js';
// import ContractsTable from './components/ContractsTable.js';
import GrowerPage from './components/GrowerPage.js';
import GrowerGallery from './components/GrowerGallery.js';
import RoastedOfferingsPage from './components/RoastedOfferingsPage.js';
import SampleCartPage from './components/SampleCartPage.js';
import MyOrdersPage from './components/MyOrdersPage.js';
import HomePage from './components/HomePage.js';
import SamplesGrid from './components/SamplesGrid.js';
import CoffeeSamplesGrid from './components/CoffeeSamplesGrid.js';
//import Web3 from 'web3';
//import ABI from './Contracts.js'


class App extends Component {
  constructor() {
    super();
    this.state = {
      // currentUser: firebase.auth.currentUser,
      authState: false,
      authData: null,
      smartContract: null,
      web3: null
    };

    this.handleAuthStateChange = this.handleAuthStateChange.bind(this);

  }
  componentDidMount() {
    //Initialize AWS Amplify Library
    Auth.configure(AwsAmplifyConfig);

    this.handleAuthStateChange();
    var date = new Date('2019-04-01T12:00:00');
  }

  componentWillUnmount() {
    //var unsubscribe = firestoreDb.collection("users").onSnapshot(() => {});
    //unsubscribe();
  }

  handleAuthStateChange() {
    Auth.currentAuthenticatedUser()
    .then(user => {
      this.setState({
        authState: true,
        authData: user
      });
    })
    .catch(err => {
      console.log('No one signed in!');
      console.log(err);
      this.setState({
        authState: false,
        authData: null
      });
    });
  }

  render() {

    return (
      <Router>
      <div className="App">


		<header className="App-header">

          {/*

            <img src="https://s3.amazonaws.com/beango.io/images/beango+logo.png" className="App-logo" alt="logo" />


		  <h1 className="App-title">Welcome to the Beango Demo</h1>
          <p className="App-intro"></p>
		 	*/}
		</header>

        <BeangoNavbar
          authData={this.state.authData}
          auth={Auth}
          handleAuthStateChange={this.handleAuthStateChange}
        />

        <Route exact path="/" render={(props) =>
          <HomePage
            {...props}
            auth={Auth}
            authData={this.state.authData}
            />
        }/>

        <Route path="/info" render={(props) =>
          //The condional below causes the app to navigate to '/' on refresh
          !this.state.authState ?
            // <Redirect to="/" />
            ''
            :
            <InfoForm
              {...props}
              auth={Auth}
              authData={this.state.authData}
            />
        } />

        <Route exact path='/growers/:id' render={(props) => {
          console.log('Passed Props: ', props.match.params.id);
          return (
            <GrowerPage
              {...props}
              auth={Auth}
              farmId={props.match.params.id}
            />
          );
        }} />

        <Route exact path="/cupping" render={(props) =>
          !this.state.authData ?
            <Redirect to="/" />
            :
            <SamplesGrid
              {...props}
              //dbRef={firestoreDb.collection("users").doc(this.state.currentUser.uid).collection("mySamples")}
              name="My Cupping Samples"
            />
        } />

        <Route exact path="/samples" render={(props) =>
          !this.state.currentUser ?
            <Redirect to="/" />
            :
            <CoffeeSamplesGrid
              {...props}
              // dbRef={firestoreDb.collection("coffees")}
              name="My Coffee Smaples"
            />
        } />

        <Route exact path="/growergallery" render={(props) => {
          return (
            <GrowerGallery
              {...props}
              // dbRef={firestoreDb.collection("growers")}
              auth={Auth}
            />
          );
        }} />

		<Route exact path="/offeringspage" render={(props) => {
          return (
            <RoastedOfferingsPage
              {...props}
              auth={Auth}
              authData={this.state.authData}
            />
          );
        }} />


		<Route exact path="/samplecartpage" render={(props) => {
          return (
            !this.state.authState ?
            ''
            :
            <SampleCartPage
              {...props}
              auth={Auth}
              authData={this.state.authData}
            />
          );
        }} />

         <Route exact path="/myorderspage" render={(props) => {
           return (
            !this.state.authState ?
            ''
            :
              <MyOrdersPage
              {...props}
              auth={Auth}
              authData={this.state.authData}
              />
            );
         }} />


        <Route exact path="/signin" render={(props) =>
          this.state.authState ? (
          <Redirect to="/" />
        ) : (
          <SignInForm
            {...props}
            auth={Auth}
            handleSignIn={this.handleAuthStateChange}
            name="Sign In"
          />
        )
        } />

        <Route exact path="/signup" render={(props) =>
          this.state.currentUser ? (
          <Redirect to="/" />
        ) : (
          <SignUpForm
            {...props}
            auth={Auth}
            name="Sign Up"
          />
        )
        } />

        <Route exact path='/emailconfirm/:id' render={(props) => {
          console.log('Passed Props: ', props.match.params.id);
          return (
            <SignUpEmailConfirm
              {...props}
              auth={Auth}
              username={props.match.params.id}
            />
          );
        }} />

        <Route exact path='/forgotpassword/:id' render={(props) => {
          console.log('Passed Props: ', props.match.params.id);
          return (
            <SignInResetPwd
              {...props}
              auth={Auth}
              username={props.match.params.id}
            />
          );
        }} />

        <Route exact path="/signinauto" render={(props) =>
          this.state.currentUser ? (
          <Redirect to="/" />
        ) : (
          <SignInAuto
            {...props}
            // auth={firebase.auth()}
            name="Auto Sign In"
          />
        )
        } />
      </div>
    </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js